import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {useSelector} from 'react-redux';

const PrivateRoute = ({component: Component, validRoles, redirect=true, ...rest}) => {
  // Add authentication.
  // @ts-ignore
  const isLoggedIn = useSelector( (state) => state.login.isLoggedIn );
  const {userInfo} = useSelector(({login}) => login);

  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ?
        validRoles.includes(userInfo.role.name) || validRoles.includes('*') ? (
          <Component {...props} />
        ) : redirect && (
          <Redirect to='/home' />
        ) : redirect && (
          <Redirect to='/login' />
        )
      }
    />
  );
};

export default PrivateRoute;
